import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';

import { ICellRendererParams } from 'ag-grid-community';
import { Observable, map, of } from 'rxjs';

import type { AsyncEnumCol } from '../../../models/columns/async-enum/async-enum-col';
import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'async-enum-renderer' },
  imports: [AsyncPipe],
  selector: '',
  template: `{{ this.value$ | async }}`,
})
export class AsyncEnumRendererComponent extends AbstractCellComponent<any, string, any, AsyncEnumCol> {
  value$: Observable<string> = of('');

  override agInit(params: ICellRendererParams) {
    super.agInit(params);
    this.value$ = (this._col?.getValues$() ?? of([])).pipe(
      map(values => values.find(value => value.id === this.params.value?.toString())?.name ?? '')
    );
  }
}
